/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_Job_SearchInputs */

const en_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited job search`)
};

const de_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Stellensuche`)
};

const fr_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche d'emploi illimitée`)
};

const es_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda de empleo ilimitada`)
};

const it_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca di lavoro illimitata`)
};

const nl_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkt baanzoeken`)
};

const pl_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nielimitowane wyszukiwanie ofert pracy`)
};

const fi_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajaton työpaikan etsintä`)
};

const da_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset jobsøgning`)
};

const sv_pricing_feature_unlimited_job_search = /** @type {(inputs: Pricing_Feature_Unlimited_Job_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsad jobbsökning`)
};

/**
* | output |
* | --- |
* | "Unlimited job search" |
*
* @param {Pricing_Feature_Unlimited_Job_SearchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_job_search = /** @type {((inputs?: Pricing_Feature_Unlimited_Job_SearchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_Job_SearchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_unlimited_job_search(inputs)
	if (locale === "fr") return fr_pricing_feature_unlimited_job_search(inputs)
	if (locale === "es") return es_pricing_feature_unlimited_job_search(inputs)
	if (locale === "it") return it_pricing_feature_unlimited_job_search(inputs)
	if (locale === "nl") return nl_pricing_feature_unlimited_job_search(inputs)
	if (locale === "pl") return pl_pricing_feature_unlimited_job_search(inputs)
	if (locale === "fi") return fi_pricing_feature_unlimited_job_search(inputs)
	if (locale === "da") return da_pricing_feature_unlimited_job_search(inputs)
	if (locale === "sv") return sv_pricing_feature_unlimited_job_search(inputs)
	return en_pricing_feature_unlimited_job_search(inputs)
});